export interface Process {
  id: number;
  idIntegracao?: number; // Adicionado conforme o schema do Swagger
  codigo?: string; // Adicionado conforme o schema do Swagger
  fase: string; // Fase atual do processo
  descricao: string; // Descrição do processo
  numeroProcesso: string; // Número do processo, será gerado pelo backend
  idTipoProcesso?: number; // ID do tipo de processo
  nomeTipoProcesso?: string; // Nome do tipo de processo
  idModalidade?: number; // ID da modalidade
  idModalidadeIntegracao?: number; // ID da modalidade de integração (novo campo)
  idModalidadeGrupo?: number; // Grupo de modalidade do processo
  idModalidadeGrupoIntegracao?: number; // Grupo de modalidade de integração (novo campo)
  empresa: Empresa; // Empresa ou cidadão associado (estrutura detalhada abaixo)
  imovel: Imovel; // Detalhes do imóvel
  dataDeInicio?: string; // Campo adicionado conforme o Swagger
  situacao: ProcessStatus; // Situação atual do processo
  etapas?: Etapa[]; // Array de etapas (opcional, conforme o Swagger)
  dueDays?: number; // Prazo em dias
  registerDate?: string; // Data de cadastro formatada
  //isSynced: boolean;
}

// Definição da estrutura de Empresa
export interface Empresa {
  id: number; // ID obrigatório
  idIntegracao: number; // ID de integração obrigatório
  codigo: string; // Código da empresa obrigatório
  cpfCnpj: string; // CPF ou CNPJ da empresa ou cidadão obrigatório
  nome: string; // Nome do cidadão ou empresa
  email?: string; // Email opcional
  inscricaoMunicipal: string; // Inscrição Municipal obrigatório
  endereco: Endereco; // Endereço principal da empresa
  enderecos?: Endereco[]; // Lista de endereços adicionais
  telefone?: string; // Telefone da empresa (opcional)
  situacao?: string; // Situação da empresa (opcional)
}

// Definição da estrutura de Imóvel
export interface Imovel {
  id: number; // ID do imóvel
  idIntegracao: number; // ID de integração
  codigo?: string; // Código do imóvel
  inscricaoImobiliaria?: string; // Inscrição imobiliária do imóvel
  unidade?: string; // Unidade do imóvel
  descricao?: string; // Descrição do imóvel
  situacao?: string; // Situação do imóvel (ex.: "Ativo", "Inativo")
  tipoImovel?: string; // Tipo de imóvel (ex.: "Apartamento", "Casa")
  apartamento?: string; // Número do apartamento, se aplicável
  bloco?: string; // Bloco do imóvel, se aplicável
  garagem?: string; // Informação de garagem, se aplicável
  sala?: string; // Informação de sala, se aplicável
  loja?: string; // Informação de loja, se aplicável
  lote?: string; // Informação de lote, se aplicável
  matricula?: string; // Número de matrícula do imóvel
  quadra?: string; // Quadra do imóvel
  setor?: string; // Setor do imóvel
  secao?: string; // Seção do imóvel
  endereco: Endereco; // Endereço principal do imóvel
  enderecos?: Endereco[]; // Lista de endereços adicionais (opcional)
  proprietarios?: Proprietario[]; // Lista de proprietários do imóvel (opcional)
}

// Definição de Proprietario (para uso dentro de Imovel)
export interface Proprietario {
  id: number; // ID do proprietário do imóvel
  idIntegracao: number; // ID de integração do proprietário
  percentual: number; // Percentual de posse do proprietário
  responsavel: boolean; // Indicador se o proprietário é o responsável pelo imóvel
  proprietario: Empresa; // Dados do proprietário (usando a estrutura de Empresa)
  imovel?: Imovel; // Informações do imóvel relacionadas ao proprietário (opcional)
}

// Definição da estrutura de Endereço (usada em Empresa e Imóvel)
export interface Endereco {
  id: number; // ID do endereço
  cep: string; // Código postal (CEP)
  logradouro: string; // Rua, avenida, etc
  numero: string; // Número do endereço
  complemento?: string; // Complemento opcional
  bairro: string; // Bairro
  cidade: string; // Cidade
  referencia?: string; // Referência opcional
  uf: string; // Estado
  principal: boolean; // Indica se é o endereço principal
  tipoEndereco: string; // Tipo do endereço (ex: COMERCIAL, RESIDENCIAL)
}

// Situações possíveis de um processo
export enum ProcessStatus {
  Aguardando = 'Aguardando', //situacao inicial
  AguardandoPagamento = 'Aguardando pagamento',
  Atrasado = 'Atrasado',
  Cancelado = 'Cancelado',
  EmAnalise = 'Em análise',
  Finalizado = 'Finalizado',
  Pendente = 'Pendente do cidadão ou empresa',
  Rascunho = 'Rascunho',
  Ativo = "ATIVO",
  Inativo = "INATIVO",
}

export interface Etapa {
  id: number; // ID da etapa
  ordem: string; // Ordem da etapa
  descricao: string; // Descrição da etapa
  responsavel: string; // Responsável pela etapa
  situacao: string; // Situação da etapa
  inicio: string; // Data de início da etapa
  prazo: string; // Prazo para a conclusão da etapa
  tipoDescricaoEtapa: string; // Tipo de descrição da etapa
  acoesRealizadas: string; // Ações realizadas na etapa
}